import Counter from './ContextInitial';

export default Counter;